import { DropdownProps } from "antd";
import { StyledDropdown } from "./atom";

export function Dropdown({ className = "", ...props }: DropdownProps) {
  return (
    <StyledDropdown
      className={`renderbus-ui--dropdown ${className}`}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      {...props}
    />
  );
}
